// Single source of truth for the public marketing nav (homepage hero header +
// the light-theme MarketingHeader used on interior pages), and for the
// content on /features and /features/:slug. Each group is its own subpage —
// the dropdown just links to it, it doesn't carry the descriptions itself.

export const FEATURE_GROUPS = [
  {
    title: "Find Opportunities",
    slug: "find-opportunities",
    summary: "Discover the right solicitations before your competitors do.",
    items: [
      { label: "SAM.gov Live Sync", blurb: "Pull solicitations on demand, filtered by NAICS, agency, and set-aside." },
      { label: "Opportunity Filtering", blurb: "Search and filter by deadline, notice type, and set-aside." },
    ],
  },
  {
    title: "AI Proposal Drafting",
    slug: "ai-proposal-drafting",
    summary: "Turn a solicitation into a compliant first draft in minutes, not days.",
    items: [
      { label: "AI Requirement Shredding", blurb: "Turn a solicitation into a structured requirements list in seconds." },
      { label: "AI Draft Generation", blurb: "RAG-grounded drafts built from your own past performance and capabilities." },
      { label: "Inline AI Assist", blurb: "Expand, condense, rewrite, or technical-ize any section on demand." },
    ],
  },
  {
    title: "Compliance & Submission",
    slug: "compliance-submission",
    summary: "Nothing slips through the cracks before you hit submit.",
    items: [
      { label: "Compliance Matrix", blurb: "Track every requirement against your response, section by section." },
      { label: "Pre-Submission Checklist", blurb: "A blocking gate that catches incomplete P0 requirements before export." },
      { label: "Multi-Volume Export", blurb: "DOCX, PDF, and a full multi-volume ZIP package, ready to submit." },
    ],
  },
  {
    title: "Team Collaboration",
    slug: "team-collaboration",
    summary: "Work the same proposal at the same time, without stepping on each other.",
    items: [
      { label: "Section Locking", blurb: "Prevent two teammates from overwriting the same section." },
      { label: "Version History", blurb: "Every edit saved, every version restorable." },
      { label: "Color-Team Snapshots", blurb: "Freeze Pink, Red, Gold, and Final reviews as immutable PDFs." },
      { label: "Threaded Comments", blurb: "Discuss a section in context, with @mentions and resolve." },
      { label: "Audit Log", blurb: "A tamper-evident record of every edit, export, and override." },
    ],
  },
  {
    title: "Knowledge Base",
    slug: "knowledge-base",
    summary: "Your company's capabilities, certifications, and past work — always at hand.",
    items: [
      { label: "Skills & Certifications", blurb: "Your team's capabilities, ready to cite in every draft." },
      { label: "NAICS Code Library", blurb: "Keep your registered codes current and searchable." },
      { label: "Clearances & Set-Asides", blurb: "Track facility clearances and small-business certifications." },
      { label: "Past Performance Library", blurb: "Your best write-ups, reusable across every proposal." },
    ],
  },
  {
    title: "Security & Administration",
    slug: "security-administration",
    summary: "Enterprise-grade control over who can see and do what.",
    items: [
      { label: "7-Role RBAC", blurb: "Administrator down to External Reviewer, scoped to what each role needs." },
      { label: "Multi-Tenant Workspaces", blurb: "Fully isolated organizations on one platform." },
      { label: "Admin Console", blurb: "Users, proposals, and knowledge base, managed in one place." },
    ],
  },
];

export const RESOURCE_LINKS = [
  { label: "Learning Center", href: "/learning" },
  { label: "Community Forum", href: "/community" },
  { label: "Success Stories", href: "/success-stories" },
];
